export const REMOTE_CONFIG_COOKIE_NAME = "rc";
export const PROD_TELEMETRY_URL = "https://telemetry.api.shapr3d.com/web";
export const STAGE_TELEMETRY_URL = "https://stage.telemetry.api.shapr3d.com/web";

export const localStorageKeys = {
  refreshToken: "token",
  accessToken: "accessToken",
} as const;

export const cookieDomain = "shapr3d.com";

export enum Environment {
  PROD = "prod",
  STAGE = "stage",
  BETA = "beta",
  LOCAL = "local",
  LOCAL_DB = "localdb",
  LOCAL_STAGE = "local-stage",
}
